<template>
  <div v-if="currentColor" class="c-product-info__color-filter">
    <div class="u-margin-bottom-small">
      <h2 class="t-heading-7 c-product-info__color-heading">
        COLOR: <span class="t-heading-9">{{ currentColor }}</span>
      </h2>
      <span class="t-paragraph t-paragraph-small"
        >({{ colorDescription }})</span
      >
    </div>
    <swatch-list
      class="l-flex--justify-start c-product-info__color-filter--no-padding"
      :product="product"
      :products="[...products, stackableBundle]"
      :render-link="renderLink"
      :active-swatch="activeSwatch"
      show-label-when="never"
      @input="handleSwatch"
    />
  </div>
</template>
<script>
import get from "lodash/get";
import SwatchList from "../swatch/SwatchList";
export default {
  components: {
    SwatchList,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    products: {
      type: Array,
      default: () => [],
    },
    renderLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stackableBundle: {},
    };
  },
  computed: {
    colorDescription() {
      return get(this.product, "metafieldsMap.color.value.description");
    },
    currentColor() {
      const color = get(this.product, "metafieldsMap.color.value");
      return color ? color.name : null;
    },
  },
  methods: {
    activeSwatch(color) {
      const product = this.product;
      return color.handle === product.handle;
    },
    handleSwatch(event) {
      if (this.renderLink === false) {
        this.$emit("update:color", event);
      }
    },
  },
  async beforeMount() {
    const { handle } = this.product;
    if (
      handle &&
      handle.includes("stackable") &&
      !handle.includes("bundle") &&
      !handle.includes("bracelet")
    )
      this.stackableBundle = await this.$api.getProduct({
        handle: "dynamic-braided-stackable-bundle-2-ring",
      });
  },
};
</script>
<style lang="scss" scoped>
.c-product-info__color-filter {
  padding: rem(20px) 0;
}
</style>
